import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import ItemBasicDetails from "./ItemBasicDetails";
import SellingPriceTable from "./SellingPriceTable";
import ItemAttachment from "./ItemAttachment";
import ItemDescription from "./ItemDescription";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  checkItemUsed,
  getFinancialYear,
  getItemmaster,
  listPriceType,
  listUserPreference,
} from "../../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import Loader from "../Components/Loader";
import {
  createItemAmountDetailsArray,
  createItemAttachmentArray,
  createItemTransaction,
  deleteItemAmountDetailsv2,
  deleteItemImages,
  updateItemmaster,
} from "../../../graphql/mutations";
import { uploadToServer } from "../../../library/upload";
import ConfirmCancel from "../../../components/modals/confirmCancel";
import moment from "moment";
import ConfirmExit from "../../../components/modals/ConfirmExit";
import DraggableAction from "../../../components/Buttons/DraggableAction";
import { sellingPriceObj, purchasePriceObj } from "./ItemListData";
import NewSellingPriceTable from "./NewSellingPriceTable";
import API_ENDPOINTS from "../../../apiEndpoints";
function PrimeAddNewItem({
  modalEvent,
  CategoryID,
  setItemID,
  closeModal,
  itemID,
  itemType,
  page,
  getItems,
  invDate,
  setAccName,
  view,
}) {
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [categoryId, setCategoryId] = useState();
  useEffect(() => {
    setCategoryId(CategoryID);
  }, [CategoryID]);

  let today = new Date();
  let yy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const navigate = useNavigate();
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let [viewState, setViewState] = useState(view);
  let location = useLocation();
  let params = modalEvent === true ? null : location.state;
  useEffect(() => {
    if (viewState && modalEvent === true) {
      params = { view: viewState };
    }
  }, [viewState]);

  const viewPage = location.pathname.includes("view");
  const todayDate = yy + "-" + mm + "-" + dd;
  const DiscountType = [
    { label: "%", value: 1 },
    { label: "₹", value: 2 },
  ];
  const CessTypes = [
    { label: "Percentage", value: 1 },
    { label: "Amount", value: 2 },
  ];
  const PriceTypes = [
    { label: "Wholesale", value: 1 },
    { label: "Retail", value: 2 },
  ];
  const GStRates =
    getCompany?.relatedcompanydetailsnew?.[0].registrationtype === 3
      ? [
          { id: 1, rate: "1%" },
          { id: 2, rate: "2%" },
          { id: 3, rate: "3%" },
          { id: 5, rate: "5%" },
          { id: 6, rate: "6%" },
        ]
      : [
          { id: 0, rate: "0%" },
          { id: 5, rate: "5%" },
          { id: 12, rate: "12%" },
          { id: 18, rate: "18%" },
          { id: 28, rate: "28%" },
        ];
  const [selectValue, setSelectValue] = useState("GOODS");
  const [units, setUnits] = useState([]);
  const [filterHSN, setFilterHSN] = useState([]);
  const [registrationType, setRegistrationType] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [purchaseIndex, setPurchaseIndex] = useState("");
  const [salesIndex, setSalesIndex] = useState("");
  const [purchaseNewFlag, setPurchaseNewFlag] = useState(true);
  const [salesNewFlag, setSalesNewFlag] = useState(true);
  const [purchaseEntryIndex, setPurchaseEntryIndex] = useState("");
  const [salesEntryIndex, setSalesEntryIndex] = useState("");
  const [deletePurchaseEntriesModal, setDeletePurchaseEntriesModal] =
    useState(false);
  const [deleteSalesEntriesModal, setDeleteSalesEntriesModal] = useState(false);
  const [isFocusPurchase, setIsFocusPurchase] = useState(false);
  const [isFocusSales, setIsFocusSales] = useState(false);
  const [isFocusSalesRow, setIsFocusSalesRow] = useState(false);
  const [isFocusPurchaseRow, setIsFocusPurchaseRow] = useState(false);
  const [fyID, setFYID] = useState("");
  const [amountSalesExcGst, setAmtSalesExcGst] = useState(0);
  const [amountSalesIncGst, setAmtSalesIncGst] = useState(0);
  const [amountPurchaseExcGst, setAmtPurchaseExcGst] = useState(0);
  const [amountPurchaseIncGst, setAmtPurchaseIncGst] = useState(0);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [cancelModal, setCancelModal] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [salesEffectiveToFlag, setSalesEffectiveToFlag] = useState(false);
  const [purchaseEffectiveToFlag, setPurchaseEffectiveToFlag] = useState(false);
  const [taxableValue, setTaxableValue] = useState("");
  const [editSalesFlag, setEditSalesFlag] = useState(false);
  const [editPurchaseFlag, setEditPurchaseFlag] = useState(false);
  const [isPurchaseValid, setPurchaseValid] = useState(true);
  const [isSalesValid, setSalesValid] = useState(true);
  const [isSalesDuplicate, setIsSalesDuplicate] = useState(false);
  const [isPurchaseDuplicate, setIsPurchaseDuplicate] = useState(false);
  const [isSalesActive, setIsSalesActive] = useState(0);
  const [isPurchaseActive, setIsPurchaseActive] = useState(0);
  const [salesFocusCell, setSalesFocusCell] = useState("priceType");
  const [purchaseFocusCell, setPurchaseFocusCell] = useState("priceType");
  const [updatedSalesPrice, setUpdatedSalesPrice] = useState([]);
  const [updatedPurchasePrice, setUpdatedPurchasePrice] = useState([]);
  const [openSalesAccordan, setOpenSalesAccordan] = useState(true);
  const [openPurchaseAccordan, setOpenPurchaseAccordan] = useState(true);
  const [tableErrArr, setTableErrArr] = useState([]);
  const [priceTypeArr, setPriceTypeArr] = useState([]);
  const [priceTypeID, setPriceTypeID] = useState("");
  const [itemUsed, setItemUsed] = useState(false);
  const [checkSalesPriceType, setCheckSalesPriceType] = useState(false);
  const [checkPurchasePriceType, setCheckPurchasePriceType] = useState(false);
  useEffect(() => {
    if (itemType) {
      setSelectValue(itemType);
    }
  }, [itemType]);
  const userPreferenceAndFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );
  const [sellingPriceRows, setSellingPriceRows] = useState([
    {
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: " ", id: "" },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: "", value: "" },
      isActive: 1,
      effectivefrom: todayDate,
      effectiveto: "",
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 1,
    },
  ]);
  const [tempSellingPriceRows, setTempSellingPriceRows] = useState({
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [editedSellingPriceRows, setEditedSellingPriceRows] = useState({
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [purchasePriceRows, setPurchasePriceRows] = useState([
    {
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: " ", id: "" },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: "", value: "" },
      isActive: 1,
      effectivefrom: todayDate,
      effectiveto: "",
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 2,
    },
  ]);
  const [tempPurchasePriceRows, setTempPurchasePriceRows] = useState({
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const [editedPurchasePriceRows, setEditedPurchasePriceRows] = useState({
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const newSalesObj = {
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 0,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 0,
    invoiceType: 1,
  };
  const newPurchaseObj = {
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 0,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 0,
    invoiceType: 2,
  };
  const newActiveSalesObj = {
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newActivePurchaseObj = {
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: "" },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const [initialState, setInitialState] = useState({
    itemCode: "",
    showItem:
      page === "Purchase" && !itemID ? [{ label: "Purchase", value: 1 }] : [],
    itemName: "",
    voucherSeries: { label: "", value: "" },
    itemCtegorey: "",
    unite: "",
    salesAccount: { label: "", value: "" },
    purchaseAccount:
      page === "Purchase" && !itemID
        ? { label: "Purchase A/c", value: 13 }
        : { label: "", value: "" },
    taxability: { label: "Taxable", value: 1 },
    hsnCode: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    reverseCharge: "2",
    purchaseInvoice: page === "Purchase" && !itemID ? 1 : 0,
    salesInvoice: 0,
    fileName: "",
    remarks: "",
    Is_Active: 1,
    errorStatus: {
      itemCode: false,
      itemName: false,
      unite: false,
      showItem: false,
      salesAccount: false,
      purchaseAccount: false,
      taxability: false,
      voucherSeries: false,

      itemCtegorey: false,

      hsnCode: false,
      reverseCharge: false,
      purchaseInvoice: false,
      salesInvoice: false,
      fileName: false,
      remarks: false,
    },
    errorFields: {
      itemCode: "",
      itemName: "",
      unite: "",
      showItem: "",
      salesAccount: "",
      purchaseAccount: "",
      taxability: "",
      voucherSeries: "",
      itemCtegorey: "",

      hsnCode: "",
      reverseCharge: "",
      purchaseInvoice: "",
      salesInvoice: "",
      fileName: "",
      remarks: "",
    },
  });
  const [data, setData] = useState({ ...initialState });
  useEffect(() => {
    if (categoryId) {
      setData((prev) => ({
        ...prev,
        itemCtegorey: categoryId.id,
      }));
      setInitialState((prev) => ({
        ...prev,
        itemCtegorey: categoryId.id,
      }));
    }
  }, [categoryId]);
  const [reNavigate, setReNavigate] = useState("");
  function deepEqual(obj1, obj2) {
    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return obj1 == obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and values are the same
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log(key, obj1[key], "//", obj2[key]);
        return false;
      }
    }

    return true;
  }
  let clickFn = (e) => {
    if (
      !deepEqual(data, initialState) ||
      attachments.length !== initialAttachments.length
    ) {
      if (!modalOpen) {
        e.preventDefault();
        e.stopPropagation();
        setModalOpen(true);
      }
      return;
    }
    if (attachments.length === initialAttachments.length) {
      attachments.map((e1, index) => {
        if (!deepEqual(attachments[index], initialAttachments[index])) {
          if (!modalOpen) {
            e.preventDefault();
            e.stopPropagation();
            setModalOpen(true);
          }
          return;
        }
      });
    }
  };
  const [aTags, setATags] = useState(document.getElementsByTagName("a").length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer?.settings);
  useEffect(() => {
    setATags(document.getElementsByTagName("a").length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName("a").length);
      }, 50);
    }
  }, [selectorDrawer, selector]);
  useEffect(() => {
    let a = document.getElementsByTagName("a");
    a = [...new Set(a)];
    let b = document.getElementsByClassName("pdf");
    a.map((e) => {
      e?.addEventListener("click", (ev) => {
        if (
          e.id !== "theme" &&
          e.id !== "selectbox" &&
          e.id !== "editN" &&
          e.id !== "Attachments" &&
          !window.location.href.includes("view") &&
          e.href !== window.location.href
        ) {
          const pathname = new URL(e.href)?.pathname;
          setReNavigate(pathname);
        }
      });
      e.removeEventListener("click", clickFn);
      if (
        e.id !== "theme" &&
        e.id !== "selectbox" &&
        e.id !== "editN" &&
        e.id !== "Attachments" &&
        !window.location.href.includes("view") &&
        e.href !== window.location.href
      ) {
        e.addEventListener("click", clickFn);
      }
    });

    return () => {
      a.map((e) => {
        e.removeEventListener("click", clickFn);
        e.removeEventListener("click", (ev) => {
          setReNavigate(e.href);
        });
      });
    };
  }, [data, attachments, aTags, attachments]);
  let [modalOpen, setModalOpen] = useState(false);
  async function getCompanyDetails() {
    try {
      if (getCompany !== null) {
        setCompanyData(getCompany);
        setRegistrationType(
          getCompany?.relatedcompanydetailsnew?.[0].registrationtype
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  function formVaidation(objData) {
    const itemCodeRegex = /^[0-9a-zA-Z !-\/:-@[-`{-~]+$/;
    const itemNameRegex = /^[0-9A-Za-z_/\\ &-]+$/;
    let isvalid = true;
    let obj = { ...data };
    Object.keys(data).map((itemKey) => {
      if (itemKey === "itemCode") {
        if (objData[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.itemCode = "Item Code is required";
          obj.errorStatus.itemCode = true;
        } else {
          obj.errorFields.itemCode = "";
          obj.errorStatus.itemCode = false;
        }
      }

      if (itemKey === "itemName") {
        if (objData[itemKey].trim().length === 0) {
          isvalid = false;
          obj.errorFields.itemName = "Item Name is required";
          obj.errorStatus.itemName = true;
        } else if (!itemNameRegex.test(data[itemKey].trim())) {
          isvalid = false;
          obj.errorFields.itemName = "Invalid Item Name";
          obj.errorStatus.itemName = true;
        } else if (data[itemKey].trim().length >= 100) {
          isvalid = false;
          obj.errorFields.itemName =
            "Item Name should be  less than 100 characters";
          obj.errorStatus.itemName = true;
        } else {
          obj.errorFields.itemName = "";
          obj.errorStatus.itemName = false;
        }
      }
      if (itemKey === "unite") {
        if (objData[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.unite = "Unit is required";
          obj.errorStatus.unite = true;
        } else {
          obj.errorFields.unite = "";
          obj.errorStatus.unite = false;
        }
      }
      if (itemKey === "salesAccount") {
        if (data.salesInvoice == 1) {
          if (objData[itemKey].value?.length <= 0) {
            isvalid = false;
            obj.errorFields.salesAccount = "Sales Account is required";
            obj.errorStatus.salesAccount = true;
          } else {
            obj.errorFields.salesAccount = "";
            obj.errorStatus.salesAccount = false;
          }
        } else {
          obj.errorFields.salesAccount = "";
          obj.errorStatus.salesAccount = false;
        }
      }
      if (itemKey === "purchaseAccount") {
        if (data.purchaseInvoice == 1) {
          if (objData[itemKey].value.length <= 0) {
            isvalid = false;
            obj.errorFields.purchaseAccount = "Purchase Account is required";
            obj.errorStatus.purchaseAccount = true;
          } else {
            obj.errorFields.purchaseAccount = "";
            obj.errorStatus.purchaseAccount = false;
          }
        } else {
          obj.errorFields.purchaseAccount = "";
          obj.errorStatus.purchaseAccount = false;
        }
      }
      if (registrationType !== 1) {
        if (itemKey === "taxability") {
          if (objData[itemKey].value === "") {
            isvalid = false;
            obj.errorFields.taxability = "Taxability is required";
            obj.errorStatus.taxability = true;
          } else {
            obj.errorFields.taxability = "";
            obj.errorStatus.taxability = false;
          }
        }
        // if (itemKey === "hsnCode") {
        //   if (data?.taxability.value === 1 || data.taxability.value === 4) {
        //     if (objData[itemKey]?.value?.toString().trim().length <= 0) {
        //       isvalid = false;
        //       obj.errorFields.hsnCode =
        //         selectValue === "GOODS"
        //           ? "HSN Code is required"
        //           : "SA Code is required";
        //       obj.errorStatus.hsnCode = true;
        //     } else {
        //       obj.errorFields.hsnCode = "";
        //       obj.errorStatus.hsnCode = false;
        //     }
        //   }
        // }
      }
      if (itemKey === "remarks") {
        if (objData[itemKey]?.trim()?.length > 250) {
          isvalid = false;
          obj.errorFields.remarks =
            "Description must be less than 250 characters";
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = "";
          obj.errorStatus.remarks = false;
        }
      }
      if (itemKey === "showItem") {
        if (data.showItem.length === 0) {
          isvalid = false;
          obj.errorFields.showItem =
            "Please select the item in Purchase or Sales Invoice";
          obj.errorStatus.showItem = true;
        } else {
          obj.errorFields.showItem = "";
          obj.errorStatus.showItem = false;
        }
      }
    });

    setData(obj);

    return isvalid;
  }
  useEffect(() => {
    let elements = document.getElementsByName(tableErrArr[0]);
    setTimeout(() => {
      if (elements.length > 0) {
        const element = elements[0];
        if (element.tabIndex === -1) {
          element.setAttribute("tabindex", "0");
        }

        element.focus();
      }
    }, 0);
  }, [tableErrArr]);

  async function saveChanges(obj) {
    try {
      let itemArr = [];
      let salesArr = [];
      let purchaseArr = [];
      let attachmentArr = [];
      const {
        itemCode,
        itemName,
        showItem,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
        remarks,
        // hsnCode,
      } = data;

      const formData = {
        itemCode,
        itemName,
        showItem,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
        remarks,
        // hsnCode,
      };
      if (formVaidation(formData)) {
        let isvalid = true;
        let validArr = [];
        let salesValidArr = [];
        let errorArr = [];

        const hasNonEmptyPriceType = sellingPriceRows.some(
          (item) =>
            item?.priceType?.label && item.priceType?.label?.trim() !== ""
        );
        setCheckSalesPriceType(hasNonEmptyPriceType);

        if (data.salesInvoice === 1 && sellingPriceRows.length > 0) {
          sellingPriceRows.map((ele, index) => {
            if (
              ele?.priceType?.label !== "" ||
              ele?.amount !== "" ||
              ele?.amount !== 0
            ) {
              if (hasNonEmptyPriceType && ele?.priceType?.label === "") {
                salesValidArr.push("Price Type");
                errorArr.push(sellingPriceObj?.priceType + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (ele?.amount === 0 || ele?.amount === "") {
                salesValidArr.push("Rate");
                errorArr.push(sellingPriceObj?.amount + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (
                registrationType !== 1 &&
                (data?.taxability?.value === 1 || data?.taxability?.value === 4)
              ) {
                if (ele?.gstRate?.id === "") {
                  salesValidArr.push("GST Rate");
                  errorArr.push(sellingPriceObj?.gstRate + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
              }
            }
          });
          salesValidArr = [...new Set(salesValidArr)];

          if (salesValidArr.length > 1) {
            showWarningSnackbar(
              ` ${salesValidArr}` + " " + " " + "are required"
            );
          }
          if (salesValidArr.length === 1) {
            showWarningSnackbar(
              ` ${salesValidArr}` + " " + " " + "is required"
            );
          }
          setOpenSalesAccordan(true);
        }
        if (data.purchaseInvoice === 1 && purchasePriceRows.length > 0) {
          purchasePriceRows.map((ele, index) => {
            if (ele?.amount !== "" && ele?.amount !== 0) {
              if (ele?.amount === 0 || ele?.amount === "") {
                validArr.push("Rate");
                errorArr.push(purchasePriceObj?.amount + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }

              if (
                registrationType !== 1 &&
                (data?.taxability?.value === 1 || data?.taxability?.value === 4)
              ) {
                if (ele?.gstRate?.id === "") {
                  validArr.push("GST Rate");
                  errorArr.push(purchasePriceObj?.gstRate + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
              }
            }
          });

          validArr = [...new Set(validArr)];

          if (validArr.length > 1) {
            showWarningSnackbar(`${validArr}` + " are required");
          }
          if (validArr.length === 1) {
            showWarningSnackbar(`${validArr}` + " is required");
          }

          setOpenSalesAccordan(true);
        }

        setTableErrArr(errorArr);
        if (isvalid) {
          setPurchaseValid(true);
          setSalesValid(true);
          setBackdropOpen(true);
          const purchaseFlag = data.purchaseInvoice;
          const invoiceFlag = data.salesInvoice;
          const inputData = {
            CurrencyCD: "13",
            HSNID: data.hsnCode.value === "" ? 0 : data.hsnCode.value,
            ItemCategoryCD: itemCtegorey === "" ? 0 : itemCtegorey,
            ItemCode: itemCode,
            ItemName: itemName,
            ItemType: selectValue,
            MeasurementCD: unite,
            PurchaseAccountID: purchaseFlag === 0 ? 0 : purchaseAccount.value,
            PurchaseInvoiceFlag: purchaseFlag,
            ReverseChargeFlag: 0,
            SalesAccountID: invoiceFlag === 0 ? 0 : salesAccount.value,
            SalesInvoiceFlag: invoiceFlag,
            TaxabilityCD: taxability.value,
            Is_Active: 1,
            SerialNumber: data.voucherSeries.value,
          };
          itemArr.push(inputData);
          let salesObj = {};

          if (
            sellingPriceRows.length > 0
            //  && data.salesInvoice === 1
          ) {
            sellingPriceRows.map((ele) => {
              // if (ele.amount !== 0 && ele.amount !== "") {
              salesObj = {
                Amount: ele.amount === "" ? 0 : ele.amount,
                EffectiveDate:
                  ele.effectivefrom === ""
                    ? 0
                    : new Date(ele?.effectivefrom).getTime() / 1000,
                ExpiredDate:
                  ele.effectiveto === ""
                    ? 0
                    : new Date(ele?.effectiveto).getTime() / 1000,
                GSTCompensationType: ele.cesstype,
                GSTCompensationValue: ele.cess === "" ? 0 : ele.cess,
                GSTRATE: ele?.gstRate?.id === "" ? 0 : Number(ele?.gstRate?.id),
                HSNID: 0,
                InvoiceType: ele.invoiceType,
                DiscountType: ele.DiscountType,
                DiscountValue: ele.DiscountValue,
                IsActive: ele.activeType,
                PriceType: ele?.priceType?.label,
                IsDefault: ele.isActive,
              };

              salesArr.push(salesObj);
              // }
            });
          } else {
            salesArr.push([
              {
                Amount: 0,
                EffectiveDate: 0,

                ExpiredDate: 0,

                GSTCompensationType: 1,
                GSTCompensationValue: 0,
                GSTRATE: 0,
                HSNID: 0,
                InvoiceType: 1,
                DiscountType: 1,
                DiscountValue: 0,
                IsActive: 1,
                PriceType: "",
                IsDefault: 1,
              },
            ]);
          }
          let purchaseObj = {};

          if (
            purchasePriceRows.length > 0
            // && data.purchaseInvoice === 1
          ) {
            purchasePriceRows.map((ele) => {
              // if (ele.amount !== 0 && ele.amount !== "") {
              purchaseObj = {
                Amount: ele.amount === "" ? 0 : ele.amount,
                EffectiveDate:
                  ele.effectivefrom === ""
                    ? 0
                    : new Date(ele?.effectivefrom).getTime() / 1000,
                ExpiredDate:
                  ele.effectiveto === ""
                    ? 0
                    : new Date(ele?.effectiveto).getTime() / 1000,
                GSTCompensationType: ele.cesstype,
                GSTCompensationValue: ele.cess === "" ? 0 : ele.cess,
                GSTRATE: ele?.gstRate?.id === "" ? 0 : Number(ele?.gstRate?.id),
                HSNID: 0,
                DiscountType: ele.DiscountType,
                DiscountValue: ele.DiscountValue,
                InvoiceType: ele.invoiceType,
                IsActive: ele.activeType,
                PriceType: ele?.priceType?.label,
                IsDefault: ele.isActive,
              };

              purchaseArr.push(purchaseObj);
              // }
            });
          } else {
            purchaseArr.push([
              {
                Amount: 0,
                EffectiveDate: 0,

                ExpiredDate: 0,

                GSTCompensationType: 1,
                GSTCompensationValue: 0,
                GSTRATE: 0,
                HSNID: 0,
                InvoiceType: 2,
                DiscountType: 1,
                DiscountValue: 0,
                IsActive: 1,
                PriceType: "",
                IsDefault: 1,
              },
            ]);
          }
          let urlArr = attachments?.filter((ele) => {
            if (ele.url !== "") {
              return ele;
            }
          });
          const attachedArr = attachments.map((ele) => ({
            ImageName: ele.DocumentName,
            ImageURL: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.ImageName}`,
            ItemID: itemID,
            DocumentName: ele.DocumentName,
            Type: ele?.Type?.split("/")[1],
          }));
          addnewItem(itemArr, [...purchaseArr, ...salesArr], attachedArr, obj);
        } else {
        }
      } else {
        setErrorArr({ ...data.errorStatus });
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listPriceDetails() {
    try {
      const res = await API.graphql(graphqlOperation(listPriceType));
      let priceTypArr = [];
      if (res.data.listPriceType !== null) {
        res.data.listPriceType.map((ele) => {
          priceTypArr.push({ label: ele.PriceType, value: ele.ID });
        });
        setPriceTypeArr(priceTypArr);
      }
    } catch (e) {
      console.log(e);
    }
  }
  async function getItemData(itemID) {
    try {
      setSalesNewFlag(true);
      setPurchaseNewFlag(true);
      setBackdropOpen(true);
      let salesObj = {};
      let purchaseObj = {};
      let salesArr = [];
      let purchaseArr = [];
      let salesEffectiveToFlag = false;
      let purchaseEffectiveToFlag = false;
      let gstRate = { label: "", value: "" };
      let priceTypeObj = { label: "", value: "" };
      let totPurchaseAmt = 0;
      let totpurchaseCess = 0;
      let gstPurchaseAmt = 0;
      let discountPurchaseAmt = 0;
      let totSalesAmt = 0;
      let totSalesCess = 0;
      let gstSalesAmt = 0;
      let discountSalesAmt = 0;
      let salesAfterDiscount = 0;
      let purchaseAfterDiscount = 0;
      let salesIsActive = 0;
      let purchaseIsActive = 0;

      const res = await API.graphql(
        graphqlOperation(getItemmaster, { ItemID: itemID })
      );
      if (res.data.getItemmaster !== null) {
        checkItemUsedInInvoice(res.data.getItemmaster.ItemID);
        setItemData(res.data.getItemmaster);
        setCategoryId(res.data.getItemmaster.ItemCategoryCD);
        res.data.getItemmaster.relatedItemAmountDetails.map((itemEle) => {
          GStRates.map((rate) => {
            if (rate.id === itemEle.GSTRATE) {
              gstRate = { rate: rate.rate, id: rate?.id };
            }
          });

          if (priceTypeID === "") {
            priceTypeArr.map((type) => {
              if (type?.label === itemEle?.PriceType) {
                priceTypeObj = { label: type?.label, value: type?.value };
              }
            });
          }
          if (itemEle.InvoiceType === 1) {
            if (itemEle.Amount !== 0) {
              salesIsActive = itemEle?.IsDefault;
              discountSalesAmt =
                itemEle.DiscountType == 1
                  ? (Number(itemEle?.Amount) * Number(itemEle.DiscountValue)) /
                    100
                  : Number(itemEle.DiscountValue);
              salesAfterDiscount =
                Number(itemEle?.Amount) - Number(discountSalesAmt);
              if (res?.data?.getItemmaster.TaxabilityCD == 4) {
                totSalesCess = 0;
                gstSalesAmt = 0;
              } else {
                totSalesCess =
                  itemEle.GSTCompensationType == 1
                    ? (Number(salesAfterDiscount) *
                        Number(itemEle?.GSTCompensationValue)) /
                      100
                    : Number(itemEle?.GSTCompensationValue);
                gstSalesAmt =
                  (Number(salesAfterDiscount) * Number(itemEle?.GSTRATE)) / 100;
              }
              totSalesAmt =
                Number(itemEle?.Amount) -
                Number(discountSalesAmt) +
                Number(gstSalesAmt) +
                Number(totSalesCess);

              salesObj = {
                amount: itemEle.Amount,
                DiscountType: itemEle.DiscountType,
                DiscountValue: itemEle.DiscountValue,
                gstRate: gstRate,
                effectivefrom: moment
                  .unix(itemEle.EffectiveDate)
                  .format("YYYY-MM-DD"),
                effectiveto:
                  itemEle.ExpiredDate !== 0
                    ? moment.unix(itemEle.ExpiredDate).format("YYYY-MM-DD")
                    : "",
                cesstype: itemEle.GSTCompensationType == 1 ? 1 : 2,
                cess: itemEle.GSTCompensationValue,
                amtaftdicount: salesAfterDiscount,
                discountAmt: discountSalesAmt,
                amountIncludingGst:
                  // Number(itemEle.Amount) -
                  // Number(itemEle.DiscountValue) +
                  // Number(itemEle.GSTCompensationValue),
                  Number(totSalesAmt),
                new: false,
                invoiceType: 1,
                activeType: itemEle.IsActive,
                isActive: itemEle.IsDefault,
                // priceType: itemEle.PriceType,
                priceType: priceTypeObj,
              };
              salesArr.push(salesObj);
            }
          }

          if (itemEle.InvoiceType === 2) {
            if (itemEle.Amount !== 0) {
              purchaseIsActive = itemEle?.IsDefault;
              discountPurchaseAmt =
                itemEle.DiscountType == 1
                  ? (Number(itemEle?.Amount) * Number(itemEle.DiscountValue)) /
                    100
                  : Number(itemEle.DiscountValue);
              purchaseAfterDiscount =
                Number(itemEle?.Amount) - Number(discountPurchaseAmt);

              totpurchaseCess =
                itemEle.GSTCompensationType == 1
                  ? (Number(purchaseAfterDiscount) *
                      Number(itemEle?.GSTCompensationValue)) /
                    100
                  : Number(itemEle?.GSTCompensationValue);
              gstPurchaseAmt =
                (Number(purchaseAfterDiscount) * Number(itemEle?.GSTRATE)) /
                100;
              totPurchaseAmt =
                Number(itemEle?.Amount) -
                Number(discountPurchaseAmt) +
                Number(gstPurchaseAmt) +
                Number(totpurchaseCess);
              purchaseObj = {
                amount: itemEle.Amount,
                DiscountType: itemEle.DiscountType,
                DiscountValue: itemEle.DiscountValue,
                gstRate: gstRate,
                effectivefrom: moment
                  .unix(itemEle.EffectiveDate)
                  .format("YYYY-MM-DD"),
                effectiveto:
                  itemEle.ExpiredDate !== 0
                    ? moment.unix(itemEle.ExpiredDate).format("YYYY-MM-DD")
                    : "",
                cesstype: itemEle.GSTCompensationType == 1 ? 1 : 2,
                cess: itemEle.GSTCompensationValue,
                amtaftdicount: purchaseAfterDiscount,
                discountAmt: discountPurchaseAmt,
                amountIncludingGst:
                  // Number(itemEle.Amount) -
                  // Number(itemEle.DiscountValue) +
                  // Number(itemEle.GSTCompensationValue),
                  Number(totPurchaseAmt),
                new: false,
                invoiceType: 2,
                activeType: itemEle.IsActive,
                isActive: itemEle.IsDefault,
                priceType: itemEle.PriceType,
              };
              purchaseArr.push(purchaseObj);
            }
          }
        });
        setIsPurchaseActive(purchaseIsActive);
        setIsSalesActive(salesIsActive);

        if (salesArr.length > 0 && priceTypeID === "") {
          salesArr.map((ele) => {
            if (ele.effectiveto === "") {
              salesEffectiveToFlag = true;
            }
          });
          let updatedSalesRows = [...salesArr, newSalesObj];
          setUpdatedSalesPrice(updatedSalesRows);
          setSellingPriceRows(updatedSalesRows);
          // setSalesEffectiveToFlag(salesEffectiveToFlag);
          // setTempSellingPriceRows(newSalesObj);
          // setEditedSellingPriceRows(newSalesObj);
        }
        if (purchaseArr.length > 0 && priceTypeID === "") {
          purchaseArr.map((ele) => {
            if (ele.effectiveto === "") {
              purchaseEffectiveToFlag = true;
            }
          });
          let updatedPurchaseRows = [...purchaseArr, newPurchaseObj];
          setUpdatedPurchasePrice(updatedPurchaseRows);
          setPurchasePriceRows(updatedPurchaseRows);
          setEditedPurchasePriceRows(newPurchaseObj);
          setTempPurchasePriceRows(newPurchaseObj);

          setPurchaseEffectiveToFlag(purchaseEffectiveToFlag);
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log("error", error);
    }
  }
  async function checkItemUsedInInvoice(itemID) {
    try {
      const res = await API.graphql(
        graphqlOperation(checkItemUsed, { ItemID: itemID })
      );

      if (res.data.checkItemUsed?.[0]?.StatusCode === "Error") {
        setItemUsed(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  const [itemBasicKey, setitemBasicKey] = useState(1);

  async function addnewItem(data1, data2, data3, obj) {
    try {
      const resItem = await API.graphql(
        graphqlOperation(createItemTransaction, {
          createItemTransactionInput: {
            ItemMaster: JSON.stringify(data1),
            ItemAmountDetails: JSON.stringify(data2),
            ItemImages: JSON.stringify(data3),
          },
        })
      );
      if (resItem.data.createItemTransaction.StatusCode === "Error") {
        setBackdropOpen(false);
        showWarningSnackbar(resItem.data.createItemTransaction.StatusMessage);
      } else {
        let responses = attachments?.map((element) => {
          if (element.file) {
            return uploadToServer(
              element.file,
              element.ImageName,
              element.Type
            );
          }
        });
        if (modalEvent) {
          showSuccessSnackbar("Item Created Successfully");
          closeModal(false);
          setItemID(resItem.data.createItemTransaction.ItemID);
          getItems(resItem.data.createItemTransaction.ItemID);
        } else {
          showSuccessSnackbar("Item Created Successfully");
          if (obj.new === false) {
            navigate("/newItemList");
          } else {
            // setitemBasicKey(prev => prev + 1)
            let a = { ...initialState };
            setCategoryId({ id: mainCategoryId });
            reset(a);
            let obj = {
              amount: 0,
              DiscountType: 1,
              DiscountValue: 0,
              gstRate: { rate: " ", id: "" },
              cesstype: 1,
              cess: 0,
              amtaftdicount: 0,
              discountAmt: 0,
              priceType: { label: "", value: "" },
              isActive: 1,
              effectivefrom: todayDate,
              effectiveto: "",
              amountIncludingGst: 0,
              timeStamp: false,
              editable: true,
              new: true,
              order: 1,
              activeType: 1,
              invoiceType: 1,
            };
            setSellingPriceRows([obj]);
            // setTempSellingPriceRows([obj])
            // setEditedSellingPriceRows([obj])
            setPurchasePriceRows([obj]);
            // setTempPurchasePriceRows([obj])
            // setEditedPurchasePriceRows([obj])
            // window.location.reload();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function saveEditChanges(obj, active) {
    try {
      const {
        itemCode,
        itemName,
        showItem,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
        // hsnCode,
      } = data;

      const formData = {
        itemCode,
        showItem,
        itemName,
        itemCtegorey,
        unite,
        salesAccount,
        purchaseAccount,
        taxability,
        // hsnCode,
      };
      if (formVaidation(formData)) {
        let isvalid = true;
        let validArr = [];
        let salesValidArr = [];
        let duplicateArr = [];
        let errorArr = [];
        const hasNonEmptyPriceType = sellingPriceRows.some(
          (item) =>
            item?.priceType?.label && item.priceType?.label?.trim() !== ""
        );
        setCheckSalesPriceType(hasNonEmptyPriceType);

        if (data.salesInvoice === 1 && sellingPriceRows.length > 0) {
          sellingPriceRows.map((ele, index) => {
            if (
              ele?.priceType?.label !== "" ||
              ele?.amount !== "" ||
              ele?.amount !== 0
            ) {
              if (hasNonEmptyPriceType && ele?.priceType?.label === "") {
                salesValidArr.push("Price Type");
                errorArr.push(sellingPriceObj?.priceType + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (ele?.amount === 0 || ele?.amount === "") {
                salesValidArr.push("Rate");
                errorArr.push(sellingPriceObj?.amount + `${index}`);
                setSalesValid(false);
                isvalid = false;
              }
              if (
                registrationType !== 1 &&
                (data?.taxability?.value === 1 || data?.taxability?.value === 4)
              ) {
                if (ele?.gstRate?.id === "") {
                  salesValidArr.push("GST Rate");
                  errorArr.push(sellingPriceObj?.gstRate + `${index}`);
                  setSalesValid(false);
                  isvalid = false;
                }
              }
            }
          });
          salesValidArr = [...new Set(salesValidArr)];

          if (salesValidArr.length > 1) {
            showWarningSnackbar(
              ` ${salesValidArr}` + " " + " " + "are required"
            );
          }
          if (salesValidArr.length === 1) {
            showWarningSnackbar(
              ` ${salesValidArr}` + " " + " " + "is required"
            );
          }
          setOpenSalesAccordan(true);
        }
        if (data.purchaseInvoice === 1 && purchasePriceRows.length > 0) {
          purchasePriceRows.map((ele, index) => {
            if (ele?.amount !== "" && ele?.amount !== 0) {
              if (ele?.amount === 0 || ele?.amount === "") {
                validArr.push("Rate");
                errorArr.push(purchasePriceObj?.amount + `${index}`);
                setPurchaseValid(false);
                isvalid = false;
              }

              if (
                registrationType !== 1 &&
                (data?.taxability?.value === 1 || data?.taxability?.value === 4)
              ) {
                if (ele?.gstRate?.id === "") {
                  validArr.push("GST Rate");
                  errorArr.push(purchasePriceObj?.gstRate + `${index}`);
                  setPurchaseValid(false);
                  isvalid = false;
                }
              }
            }
          });

          validArr = [...new Set(validArr)];

          if (validArr.length > 1) {
            showWarningSnackbar(`${validArr}` + " are required");
          }
          if (validArr.length === 1) {
            showWarningSnackbar(`${validArr}` + " is required");
          }

          setOpenSalesAccordan(true);
        }
        if (isvalid) {
          const purchaseFlag = data.purchaseInvoice;
          const invoiceFlag = data.salesInvoice;
          const inputData = {
            CurrencyCD: "13",
            ItemCategoryCD: itemCtegorey == "" ? 0 : itemCtegorey,
            ItemCode: itemCode,
            ItemID: itemData.ItemID,
            HSNID: data.hsnCode.value === "" ? 0 : data.hsnCode.value,
            ItemName: itemName,
            ItemType: selectValue,
            MeasurementCD: unite,
            PurchaseAccountID: purchaseFlag === 0 ? 0 : purchaseAccount.value,
            PurchaseInvoiceFlag: purchaseFlag,
            ReverseChargeFlag: 0,
            SalesAccountID: invoiceFlag === 0 ? 0 : salesAccount.value,
            SalesInvoiceFlag: invoiceFlag,
            TaxabilityCD: taxability.value,
            EnteredTimeStamp: itemData?.EnteredTimeStamp,
            SerialNumber: data?.voucherSeries.value,
            Is_Active: data.Is_Active,
          };
          if (active == "active") {
            let passData = {
              ...inputData,
              Is_Active: data.Is_Active == 1 ? 0 : 1,
            };
            activeInSActive(passData);
          } else updateItem(inputData, obj);
        } else {
          setTableErrArr(errorArr);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  let activeInSActive = async (inputData) => {
    try {
      const res = await API.graphql(
        graphqlOperation(updateItemmaster, { updateItemmasterInput: inputData })
      );
      if (res.data.updateItemmaster !== null) {
        showSuccessSnackbar(
          `Item marked as ${inputData.Is_Active == 1 ? "inactive" : "active"} `
        );
        if (!params?.view) {
          navigate("/newItemList");
        } else {
          getCompanyDetails();
          listUserPreferenceData();
          listPriceDetails();
        }
      }
    } catch (e) {
      console.log(e, "error");
    }
  };
  async function updateItem(inputData, obj) {
    try {
      if (data.purchaseInvoice === 0 && purchasePriceRows.length > 0) {
        const itemDelete = await API.graphql(
          graphqlOperation(deleteItemAmountDetailsv2, {
            itemAmountDelReqInput: {
              ItemID: itemID,
              InvoiceType: 2,
            },
          })
        );
      }
      if (data.salesInvoice === 0 && sellingPriceRows.length > 0) {
        const itemDelete = await API.graphql(
          graphqlOperation(deleteItemAmountDetailsv2, {
            itemAmountDelReqInput: {
              ItemID: itemData.ItemID,
              InvoiceType: 1,
            },
          })
        );
      }
      if (
        sellingPriceRows.length > 0
        //  && data.salesInvoice === 1
      ) {
        addSellingPrice(itemData.ItemID, sellingPriceRows);
      }

      if (
        purchasePriceRows.length > 0
        //  && data?.purchaseInvoice === 1
      ) {
        addPurchasePrice(itemData.ItemID, purchasePriceRows);
      }
      const res = await API.graphql(
        graphqlOperation(updateItemmaster, { updateItemmasterInput: inputData })
      );
      if (res.data.updateItemmaster !== null) {
        const itemImage = await API.graphql(
          graphqlOperation(deleteItemImages, {
            ItemID: res.data.updateItemmaster.ItemID,
          })
        );
        if (itemImage.data.deleteItemImages !== null) {
          addAttachmets(res.data.updateItemmaster.ItemID);
        }

        if (modalEvent) {
          showSuccessSnackbar("Item Updated Successfully");
          setItemID(res.data.updateItemmaster.ItemID);
          getItems(res.data.updateItemmaster.ItemID);
          closeModal(false);
        } else {
          showSuccessSnackbar("Item Updated Successfully");
          navigate("/newItemList");
        }
      } else {
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function addSellingPrice(itemID, rows) {
    try {
      let obj = {};
      let arr = [];
      if (rows.length > 0) {
        rows.map((ele) => {
          obj = {
            Amount: ele.amount === "" ? 0 : ele.amount,
            EffectiveDate:
              ele.effectivefrom === ""
                ? 0
                : new Date(ele?.effectivefrom).getTime() / 1000,
            ExpiredDate:
              ele.effectiveto === ""
                ? 0
                : new Date(ele?.effectiveto).getTime() / 1000,
            GSTCompensationType: ele.cesstype,
            GSTCompensationValue: ele.cess === "" ? 0 : ele.cess,
            GSTRATE: ele?.gstRate?.id === "" ? 0 : Number(ele?.gstRate?.id),
            HSNID: 0,
            ItemID: itemID,
            DiscountType: ele.DiscountType,
            DiscountValue: ele.DiscountValue,
            InvoiceType: ele.invoiceType,
            IsActive: ele.activeType,
            PriceType: ele?.priceType?.label,
            IsDefault: ele.isActive,
          };
          arr.push(obj);
        });
      } else {
        arr.push([
          {
            Amount: 0,
            EffectiveDate: 0,

            ExpiredDate: 0,

            GSTCompensationType: 1,
            GSTCompensationValue: 0,
            GSTRATE: 0,
            HSNID: 0,
            InvoiceType: 1,
            DiscountType: 1,
            DiscountValue: 0,
            IsActive: 1,
            PriceType: "",
            IsDefault: 1,
          },
        ]);
      }
      addItemAmount(arr);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function addPurchasePrice(itemID, rows) {
    try {
      let obj = {};
      let arr = [];
      if (rows.length > 0) {
        rows.map((ele) => {
          obj = {
            Amount: ele.amount === "" ? 0 : ele.amount,
            EffectiveDate:
              ele.effectivefrom === ""
                ? 0
                : new Date(ele?.effectivefrom).getTime() / 1000,
            ExpiredDate:
              ele.effectiveto === ""
                ? 0
                : new Date(ele?.effectiveto).getTime() / 1000,
            GSTCompensationType: ele.cesstype,
            GSTCompensationValue: ele.cess === "" ? 0 : ele.cess,
            GSTRATE: ele?.gstRate?.id === "" ? 0 : Number(ele?.gstRate?.id),
            HSNID: 0,
            ItemID: itemID,
            DiscountType: ele.DiscountType,
            DiscountValue: ele.DiscountValue,
            InvoiceType: ele.invoiceType,
            IsActive: ele.activeType,
            PriceType: ele?.priceType?.label,
            IsDefault: ele.isActive,
          };
          arr.push(obj);
        });
      } else {
        arr.push([
          {
            Amount: 0,
            EffectiveDate: 0,

            ExpiredDate: 0,

            GSTCompensationType: 1,
            GSTCompensationValue: 0,
            GSTRATE: 0,
            HSNID: 0,
            InvoiceType: 2,
            DiscountType: 1,
            DiscountValue: 0,
            IsActive: 1,
            PriceType: "",
            IsDefault: 1,
          },
        ]);
      }
      addItemAmount(arr);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function addAttachmets(itemID) {
    try {
      const attachedArr = attachments.map((ele) => ({
        ImageName: ele.ImageName,
        ImageURL: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.ImageName}`,
        ItemID: itemID,
        DocumentName: ele.DocumentName,
        Type: ele?.Type,
      }));

      const attachRes = await API.graphql(
        graphqlOperation(createItemAttachmentArray, {
          ItemAttachment: JSON.stringify(attachedArr),
        })
      );
      let responses = attachments?.map((element) => {
        if (element.file) {
          return uploadToServer(element.file, element.ImageName, element.Type);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async function addItemAmount(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createItemAmountDetailsArray, {
          createItemAmountDetailsInputArray: JSON.stringify(data),
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  async function listUserPreferenceData() {
    try {
      const res = await API.graphql(graphqlOperation(listUserPreference));
      let attributeValue = "";
      let bankAttributeValue = "";
      res?.data?.listUserPreference?.map((ele) => {
        if (ele.AttributeTypeCD === "SelectedFinYear") {
          attributeValue = ele.AttributeValue;
        }
        if (ele.AttributeTypeCD === "SelectedBankDetails") {
          bankAttributeValue = ele.AttributeValue;
        }
      });
      setFYID(attributeValue);
      getFY(attributeValue);
    } catch (error) {
      console.log("error", error);
    }
  }

  async function getFY(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(getFinancialYear, { FinancialYearID: data })
      );
      if (res.data.getFinancialYear !== null) {
        setStartDate(res.data.getFinancialYear.StartDate);
        setEndDate(res.data.getFinancialYear.EndDate);
      }
    } catch (error) {
      console.log("Error", error);
    }
  }

  function reset(value) {
    let valueData = value == undefined ? initialState : value;
    setitemBasicKey((prev) => prev + 1);
    // setCategoryId(mainCategoryId);
    setData(valueData);

    // setData((prev) => ({
    //   ...prev,
    //   itemCode: "",
    //   // showItem: value === "GOODS" ? [] : [{ label: "Sales", value: 2 }],
    //   showItem: [],
    //   itemName: "",
    //   voucherSeries: { label: "", value: "" },
    //   itemCtegorey: "",
    //   unite: "",
    //   salesAccount: { label: "", value: "" },
    //   purchaseAccount: { label: "", value: "" },
    //   taxability: { label: "Taxable", value: 1 },
    //   hsnCode: {
    //     label: "",
    //     value: "",
    //     companyID: "",
    //     hsnID: "",
    //     codeType: "",
    //     description: "",
    //   },
    //   reverseCharge: "2",
    //   purchaseInvoice: 0,
    //   salesInvoice: 0,
    //   fileName: "",
    //   remarks: "",
    //   Is_Active: 1,
    //   errorStatus: {
    //     ...prev.errorStatus,
    //     itemCode: false,
    //     voucherSeries: false,
    //     showItem: false,
    //     itemName: false,
    //     itemCtegorey: false,
    //     unite: false,
    //     salesAccount: false,
    //     purchaseAccount: false,
    //     taxability: false,
    //     hsnCode: false,
    //     reverseCharge: false,
    //     purchaseInvoice: false,
    //     salesInvoice: false,
    //     fileName: false,
    //     remarks: false,
    //   },
    //   errorFields: {
    //     ...prev.errorFields,
    //     itemCode: "",
    //     showItem: "",
    //     voucherSeries: "",
    //     itemName: "",
    //     itemCtegorey: "",
    //     unite: "",
    //     salesAccount: "",
    //     purchaseAccount: "",
    //     taxability: "",
    //     hsnCode: "",
    //     reverseCharge: "",
    //     purchaseInvoice: "",
    //     salesInvoice: "",
    //     fileName: "",
    //     remarks: "",
    //   },
    // }));
  }
  useEffect(() => {
    getCompanyDetails();
    listUserPreferenceData();
    listPriceDetails();
  }, []);

  useEffect(() => {
    if (itemID || params) {
      getItemData(itemID || params?.id);
      if (params?.id !== "" || params?.id !== undefined) {
        if (
          params?.taxType == 2 ||
          params?.taxType == 3 ||
          params?.taxType == 5
        ) {
          setRegistrationType(1);
        }
        setSelectValue(params?.type === 2 ? "SERVICE" : "GOODS");
      }
    }
  }, [itemID, params, priceTypeArr]);
  useEffect(() => {
    if (sellingPriceRows.length === 1 && editSalesFlag === false) {
      // setEditedSellingPriceRows((prev) => ({
      //   ...prev,
      //   effectivefrom: todayDate,
      // }));
      setEditedSellingPriceRows(newActiveSalesObj);
    }
    if (purchasePriceRows.length === 1 && editPurchaseFlag === false) {
      // setEditedPurchasePriceRows((prev) => ({
      //   ...prev,
      //   effectivefrom: todayDate,
      // }));
      setEditedPurchasePriceRows(newActivePurchaseObj);
    }
    if (sellingPriceRows.length === 0) {
      setSalesEffectiveToFlag(false);
    }
    if (purchasePriceRows.length === 0) {
      setPurchaseEffectiveToFlag(false);
    }
  }, [sellingPriceRows, purchasePriceRows]);

  const radioRef = useRef(null);
  const radioRef2 = useRef(null);
  useEffect(() => {
    if (radioRef.current && selectValue !== "GOODS") {
      radioRef.current.focus();
    } else if (radioRef2.current && selectValue == "GOODS") {
      radioRef2.current.focus();
    }
  }, [selectValue]);
  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        // const yOffset = -120;
        // const y = element?.getBoundingClientRect()?.top + window?.scrollY + yOffset;
        // window.scrollTo({ top: y, behavior: "smooth" });

        // Focus the element after scrolling

        element?.focus();
      }
    }
  }, [errorArr]);

  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );

  return (
    <Box
      className="PageHeight"
      sx={{
        padding: {
          xs: !modalEvent ? "80px 20px 20px 20px" : "40px 10px 10px 10px",
          sm: !modalEvent ? "70px 30px 20px 80px" : "1px 3px 0px 10px",
        },
        m: 1,
      }}
    >
      {modalOpen && (
        <ConfirmExit
          open={modalOpen}
          setOpen={setModalOpen}
          reNavigate={reNavigate}
        />
      )}
      {/* {(params?.view === true || view) && (
        <Box
          sx={{
            position: "sticky", // Make the box sticky
            top: "10px", // Adjust the distance from the top as needed
            // backgroundColor: "white", // Set a background color
            borderRadius: "8px",
            marginBottom: "0px",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            transition: "all 1s ease-in-out",
            zIndex: 1100, // Ensure the box stays above other content
          }}
        >
          <Alert
            variant="standard"
            sx={{
              boxShadow: "none",
              width: 400,
              zIndex: 1000,
            }}
            severity="info"
          >
            Fields are disabled. To make changes{" "}
            <Link
              id="EnableEdit"
              underline="hover"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (Freeze == 1) {
                  return handleFreeze();
                }
                navigate("/edititem", {
                  state: { id: params?.id, view: false, type: params.type },
                });
              }}
            >
              Enable Edit
              <Edit sx={{ fontSize: "14px" }} />
            </Link>
          </Alert>
        </Box>
      )} */}

      {/* {params?.view === true && invoiceEntry.CancelFlag ? (
        <Box
          sx={{
            position: "sticky", // Make the box sticky
            top: "10px", // Adjust the distance from the top as needed
            // backgroundColor: "white", // Set a background color
            borderRadius: "8px",
            marginBottom: "0px",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            transition: "all 1s ease-in-out",
            zIndex: 1100, // Ensure the box stays above other content
          }}
        >
          <Alert
            variant="standard"
            sx={{
              color: "red",
              boxShadow: "none",
              width: 400,
              zIndex: 1000,
            }}
            severity="error"
          >
            {invoiceEntry.CancelFlag === 1 ? "Invoice cancelled. No further updates can be made." : null}
          </Alert>
        </Box>
      ) : null} */}

      {!itemID && page !== "Dashboard" && (
        <Paper
          sx={{
            borderRadius: "8px",
            backgroundColor: "background.paper",
            marginBottom: "10px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            borderRadius: "8px",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
          }}
        >
          {" "}
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              sx={{
                border: "2px solid transparent",
                pl: "5px",
                "&:focus-within": {
                  borderColor: "primary.main", // Highlight border color
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderRadius: "4px",
                },
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.stopPropagation();
                  event.preventDefault();
                  setSelectValue(selectValue == "GOODS" ? "SERVICE" : "GOODS");
                }
              }}
            >
              <FormControlLabel
                onChange={() => {
                  setSelectValue("GOODS");
                  let a = { ...initialState };
                  a.itemCtegorey = "1";
                  setInitialState(a);
                  reset(a);
                }}
                checked={
                  selectValue == "GOODS" || itemType == "GOODS" ? true : false
                }
                disabled={itemID || params !== null ? true : false}
                value={selectValue}
                control={
                  <Radio
                    autoFocus
                    disableRipple={false}
                    disableFocusRipple={false}
                    ref={radioRef2}
                  />
                }
                label="GOODS"
              />
              <FormControlLabel
                onChange={() => {
                  setSelectValue("SERVICE");
                  let a = { ...initialState };
                  a.itemCtegorey = "2";
                  setInitialState(a);
                  reset(a);
                }}
                checked={
                  selectValue == "SERVICE" || itemType == "SERVICE"
                    ? true
                    : false
                }
                disabled={
                  itemID ||
                  itemID ||
                  params !== null ||
                  (modalEvent && page === "Purchase")
                    ? true
                    : false
                }
                value="SERVICE"
                control={
                  <Radio
                    autoFocus
                    disableRipple={false}
                    disableFocusRipple={false}
                    ref={radioRef}
                  />
                }
                label="SERVICE"
              />
            </RadioGroup>
          </FormControl>
        </Paper>
      )}
      <Paper
        sx={{
          borderRadius: "8px",
          backgroundColor: "background.paper",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <ItemBasicDetails
          view={viewState}
          key={itemBasicKey}
          mainCategoryId={mainCategoryId}
          setMainCategoryId={setMainCategoryId}
          setCategoryId={setCategoryId}
          categoryId={categoryId}
          Type={selectValue}
          data={data}
          setData={setData}
          setInitialState={setInitialState}
          units={units}
          setUnits={setUnits}
          filterHSN={filterHSN}
          setFilterHSN={setFilterHSN}
          companyData={companyData}
          registrationType={registrationType}
          fyID={userPreferenceAndFY?.financialYear?.FinancialYearID}
          setRegistrationType={setRegistrationType}
          setBackdropOpen={setBackdropOpen}
          itemData={itemData}
          setTaxableValue={setTaxableValue}
          page={page}
          itemID={itemID}
          setAccName={setAccName}
          newSalesObj={newActiveSalesObj}
          newPurchaseObj={newActivePurchaseObj}
          updatedPurchasePrice={updatedPurchasePrice}
          updatedSalesPrice={updatedSalesPrice}
          setSellingPriceRows={setSellingPriceRows}
          setPurchasePriceRows={setPurchasePriceRows}
          setTempPurchasePriceRows={setTempPurchasePriceRows}
          setTempSellingPriceRows={setTempSellingPriceRows}
          setEditedPurchasePriceRows={setEditedPurchasePriceRows}
          setEditedSellingPriceRows={setEditedSellingPriceRows}
          sellingPriceRows={sellingPriceRows}
          purchasePriceRows={purchasePriceRows}
          setUpdatedPurchasePrice={setUpdatedPurchasePrice}
          setUpdatedSalesPrice={setUpdatedSalesPrice}
          setTableErrArr={setTableErrArr}
        />
      </Paper>

      <Paper
        sx={{
          borderRadius: "8px",
          backgroundColor: "background.paper",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
          pointerEvents:
            data.itemName === "" || data.showItem.length === 0 ? "none" : "",
        }}
      >
        <NewSellingPriceTable
          key={itemBasicKey}
          Type={selectValue}
          tableType="Sales"
          rows={sellingPriceRows}
          tempRow={tempSellingPriceRows}
          editedRow={editedSellingPriceRows}
          setRows={setSellingPriceRows}
          setEditedRow={setEditedSellingPriceRows}
          setTempRow={setTempSellingPriceRows}
          data={data}
          companyData={companyData}
          registrationType={registrationType}
          endDate={endDate}
          startDate={startDate}
          setNewItemRowStatus={setSalesNewFlag}
          newItemRowStatus={salesNewFlag}
          setIsFocusItem={setIsFocusSales}
          isFocusItem={isFocusSales}
          rowIndex={salesIndex}
          setRowIndex={setSalesIndex}
          deleteEntriesModal={deleteSalesEntriesModal}
          setDeleteEntriesModal={setDeleteSalesEntriesModal}
          entryIndex={salesEntryIndex}
          setEntryIndex={setSalesEntryIndex}
          todayDate={todayDate}
          setRegistrationType={setRegistrationType}
          setAmtExcGst={setAmtSalesExcGst}
          setAmtIncGst={setAmtSalesIncGst}
          amountExcGst={amountSalesExcGst}
          amountIncGst={amountSalesIncGst}
          setBackdropOpen={setBackdropOpen}
          GStRates={GStRates}
          CessTypes={CessTypes}
          DiscountType={DiscountType}
          effectiveToFlag={salesEffectiveToFlag}
          setEffectiveToFlag={setSalesEffectiveToFlag}
          taxableValue={taxableValue}
          editFlag={editSalesFlag}
          setEditFlag={setEditSalesFlag}
          isFocusRow={isFocusSalesRow}
          setIsFocusRow={setIsFocusSalesRow}
          isValid={isSalesValid}
          setIsValid={setSalesValid}
          PriceTypes={PriceTypes}
          isDuplicate={isSalesDuplicate}
          setIsDuplicate={setIsSalesDuplicate}
          isActive={isSalesActive}
          setIsActive={setIsSalesActive}
          invDate={invDate}
          itemUsed={itemUsed}
          activeFlag={data.salesInvoice}
          focusCell={salesFocusCell}
          setFocusCell={setSalesFocusCell}
          params={params || { view: viewState }}
          openAccordan={openSalesAccordan}
          setOpenAccordan={setOpenSalesAccordan}
          priceTypeArr={priceTypeArr}
          setPriceTypeArr={setPriceTypeArr}
          priceTypeID={priceTypeID}
          setPriceTypeID={setPriceTypeID}
          setUpdatedPrice={setUpdatedSalesPrice}
          newArr={newSalesObj}
          newActiveArr={newActiveSalesObj}
          emptyPriceType={checkSalesPriceType}
          setEmptyPriceType={setCheckSalesPriceType}
          nameObj={sellingPriceObj}
          setTableErrArr={setTableErrArr}
        />
      </Paper>

      <Paper
        sx={{
          borderRadius: "8px",
          backgroundColor: "background.paper",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
          pointerEvents:
            data.itemName === "" || data.showItem.length === 0 ? "none" : "",
        }}
      >
        <NewSellingPriceTable
          key={itemBasicKey}
          Type={selectValue}
          tableType="Purchase"
          rows={purchasePriceRows}
          tempRow={tempPurchasePriceRows}
          editedRow={editedPurchasePriceRows}
          setRows={setPurchasePriceRows}
          setEditedRow={setEditedPurchasePriceRows}
          setTempRow={setTempPurchasePriceRows}
          data={data}
          endDate={endDate}
          startDate={startDate}
          setNewItemRowStatus={setPurchaseNewFlag}
          newItemRowStatus={purchaseNewFlag}
          setIsFocusItem={setIsFocusPurchase}
          isFocusItem={isFocusPurchase}
          rowIndex={purchaseIndex}
          setRowIndex={setPurchaseIndex}
          deleteEntriesModal={deletePurchaseEntriesModal}
          setDeleteEntriesModal={setDeletePurchaseEntriesModal}
          entryIndex={purchaseEntryIndex}
          setEntryIndex={setPurchaseEntryIndex}
          todayDate={todayDate}
          registrationType={registrationType}
          setRegistrationType={setRegistrationType}
          setAmtExcGst={setAmtPurchaseExcGst}
          setAmtIncGst={setAmtPurchaseIncGst}
          amountExcGst={amountPurchaseExcGst}
          amountIncGst={amountPurchaseIncGst}
          setBackdropOpen={setBackdropOpen}
          companyData={companyData}
          GStRates={GStRates}
          CessTypes={CessTypes}
          DiscountType={DiscountType}
          effectiveToFlag={purchaseEffectiveToFlag}
          setEffectiveToFlag={setPurchaseEffectiveToFlag}
          taxableValue={taxableValue}
          editFlag={editPurchaseFlag}
          setEditFlag={setEditPurchaseFlag}
          isFocusRow={isFocusPurchaseRow}
          setIsFocusRow={setIsFocusPurchaseRow}
          isValid={isPurchaseValid}
          setIsValid={setPurchaseValid}
          PriceTypes={PriceTypes}
          isDuplicate={isPurchaseDuplicate}
          setIsDuplicate={setIsPurchaseDuplicate}
          isActive={isPurchaseActive}
          setIsActive={setIsPurchaseActive}
          invDate={invDate}
          itemUsed={itemUsed}
          activeFlag={data.purchaseInvoice}
          focusCell={purchaseFocusCell}
          setFocusCell={setPurchaseFocusCell}
          params={params || { view: viewState }}
          openAccordan={openPurchaseAccordan}
          setOpenAccordan={setOpenPurchaseAccordan}
          priceTypeArr={priceTypeArr}
          setPriceTypeArr={setPriceTypeArr}
          priceTypeID={priceTypeID}
          setPriceTypeID={setPriceTypeID}
          setUpdatedPrice={setUpdatedPurchasePrice}
          newArr={newPurchaseObj}
          newActiveArr={newActivePurchaseObj}
          emptyPriceType={checkPurchasePriceType}
          setEmptyPriceType={setCheckPurchasePriceType}
          nameObj={purchasePriceObj}
          setTableErrArr={setTableErrArr}
        />
      </Paper>

      <Paper
        sx={{
          borderRadius: "8px",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3}>
            <ItemDescription
              data={data}
              setData={setData}
              params={params || { view: viewState }}
            />
          </Grid>
          <Grid item xs={12} lg={9}>
            <ItemAttachment
              view={viewPage}
              attachments={attachments}
              setAttachments={setAttachments}
              setInitialAttachments={setInitialAttachments}
              itemData={itemData}
              params={params || { view: viewState }}
            />
          </Grid>
        </Grid>
      </Paper>
      {/* {(params?.view !== true && !view) ? ( */}
      <Box>
        {/* <FloatingButton
          setCancelModal={setCancelModal}
          saveChanges={() => {
            saveChanges({ new: false });
          }}
          saveChangesPrint={() => {
            saveChanges({ print: false, preview: false });
          }}
          saveEditChanges={() => saveEditChanges({ new: false })}
          saveandNew={() => saveChanges({ new: true })}
          saveChangesFlag={true}
          isModal={modalEvent}
          setPreviewModal={false}
          printButton={false}
          paramsID={itemID}
          paramsView={false}
        /> */}
        <DraggableAction
          actionType={
            (itemID || params?.id) &&
            params?.view !== true &&
            viewState !== true
              ? "edit"
              : "save"
          }
          onSave={
            (itemID || params?.id) &&
            params?.view !== true &&
            viewState !== true
              ? async () => {
                  await saveEditChanges({ new: false });
                  if (closeModal) {
                    closeModal(false);
                  }
                }
              : params?.view !== true && viewState !== true
              ? async () => {
                  await saveChanges({ new: false });
                  if (closeModal) {
                    closeModal(false);
                  }
                }
              : null
          }
          onEnableEdit={() => {
            if (data?.Is_Active == 0) {
              return saveEditChanges({ new: false }, "active");
            }
            if (modalEvent == true) {
              params = { view: false };
              return setViewState(false);
            }
            navigate("/edititem", {
              state: { id: params?.id, view: false, type: params?.type },
            });
          }}
          onExit={
            itemID ||
            (params?.id !== "" &&
              params?.id !== undefined &&
              params?.view !== true)
              ? null
              : () => {
                  if (closeModal) {
                    closeModal(false);
                  }
                  setCancelModal(true);
                }
          }
          onReset={
            !(itemID || (params?.id !== "" && params?.id !== undefined))
              ? () => {
                  if (
                    itemID ||
                    (params?.id !== "" && params?.id !== undefined)
                  ) {
                    getItemData(itemID || params?.id);
                    // setAttachments([])
                  } else {
                    setCategoryId(mainCategoryId);
                    setAttachments([]);
                    let obj = [
                      {
                        amount: 0,
                        DiscountType: 1,
                        DiscountValue: 0,
                        gstRate: { rate: " ", id: "" },
                        cesstype: 1,
                        cess: 0,
                        amtaftdicount: 0,
                        discountAmt: 0,
                        priceType: { label: "", value: "" },
                        isActive: 1,
                        effectivefrom: todayDate,
                        effectiveto: "",
                        amountIncludingGst: 0,
                        timeStamp: false,
                        editable: true,
                        new: true,
                        order: 1,
                        activeType: 1,
                        invoiceType: 1,
                      },
                    ];
                    setSellingPriceRows(obj);
                    setPurchasePriceRows(obj);
                  }
                  reset();
                }
              : null
          }
          onSaveNew={
            modalEvent
              ? undefined
              : (itemID || params?.id) && params?.view !== true && view !== true
              ? () => {
                  saveChanges({ new: true });
                }
              : null
          }
          from={data?.Is_Active == 1 ? "inactive" : "active"}
          onCancel={
            itemID || (params?.id !== "" && params?.id !== undefined)
              ? () => {
                  saveEditChanges({ new: false }, "active");
                }
              : null
          }
        />
      </Box>
      {/* ) : null} */}
      <ConfirmCancel
        open={cancelModal}
        setOpen={setCancelModal}
        path="newItemList"
      />
      <Loader open={backdropOpen}></Loader>
    </Box>
  );
}

export default PrimeAddNewItem;
